export enum AUDIT_MODELS {
  APPLICATION = "ApplicationApplication",
  ASSESSMENT = "AssessmentAssessment",
  FUNDER = "FunderAssessment",
  WORKFLOW = "WorkflowWorkflow",
  LMS_ASSESSMENT_SUBMISSION = "LmsAssessmentSubmission",
}
